import {Outlet, NavLink, useNavigate} from 'react-router-dom'
import {useAuth} from '../../app/modules/auth'
import {PageDataProvider} from './core'
import {BRAND, LOGO} from '../../app/brand'

// Trimmed to the essentials: Dashboard, Users, Settings. (Logout is a separate
// button at the bottom of the sidebar.) The other pages still exist and remain
// reachable by URL/route — they are just hidden from the nav.
const NAV_ITEMS = [
  {
    to: '/dashboard',
    label: 'Dashboard',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <rect x='3' y='3' width='7' height='7'/><rect x='14' y='3' width='7' height='7'/>
        <rect x='3' y='14' width='7' height='7'/><rect x='14' y='14' width='7' height='7'/>
      </svg>
    ),
  },
  {
    to: '/users',
    label: 'Users',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/>
        <circle cx='12' cy='7' r='4'/>
      </svg>
    ),
  },
  {
    to: '/drivers',
    label: 'Drivers',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <path d='M5 17H3v-4l2-5h11l4 5v4h-2'/><circle cx='7.5' cy='17' r='2'/><circle cx='16.5' cy='17' r='2'/>
      </svg>
    ),
  },
  {
    to: '/business',
    label: 'Business',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <path d='M3 9l1-5h16l1 5'/><path d='M4 9v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9'/><path d='M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0'/>
      </svg>
    ),
  },
  {
    to: '/waitlist',
    label: 'Waitlist',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <path d='M4 4h16v4l-6 4 6 4v4H4v-4l6-4-6-4z'/>
      </svg>
    ),
  },
  {
    to: '/payouts',
    label: 'Withdrawals',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <rect x='2' y='6' width='20' height='13' rx='2'/>
        <path d='M2 10h20'/><path d='M7 15h3'/>
      </svg>
    ),
  },
  {
    to: '/partners',
    label: 'Partner Applications',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <path d='M9 11l2 2 4-4'/><path d='M21 12a9 9 0 1 1-6.2-8.56'/>
      </svg>
    ),
  },
  {
    to: '/service-categories',
    label: 'Service Categories',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <rect x='3' y='3' width='7' height='7' rx='1'/><rect x='14' y='3' width='7' height='7' rx='1'/>
        <rect x='14' y='14' width='7' height='7' rx='1'/><rect x='3' y='14' width='7' height='7' rx='1'/>
      </svg>
    ),
  },
  {
    to: '/sub-categories',
    label: 'Sub Categories',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <rect x='3' y='3' width='7' height='7' rx='1'/><path d='M10 17h4a3 3 0 0 0 3-3v-1'/>
        <path d='M6.5 10v4a3 3 0 0 0 3 3H10'/><circle cx='18' cy='7' r='3'/><circle cx='18' cy='18' r='3'/>
      </svg>
    ),
  },
  {
    to: '/service-items',
    label: 'Service Items',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <line x1='8' y1='6' x2='21' y2='6'/><line x1='8' y1='12' x2='21' y2='12'/><line x1='8' y1='18' x2='21' y2='18'/>
        <line x1='3' y1='6' x2='3.01' y2='6'/><line x1='3' y1='12' x2='3.01' y2='12'/><line x1='3' y1='18' x2='3.01' y2='18'/>
      </svg>
    ),
  },
  {
    to: '/account/settings',
    label: 'Settings',
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <circle cx='12' cy='12' r='3'/>
        <path d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z'/>
      </svg>
    ),
  },
]

const MasterLayout = () => {
  const {currentUser, logout} = useAuth()
  const navigate = useNavigate()

  const initials =
    ((currentUser?.first_name?.[0] ?? '') + (currentUser?.last_name?.[0] ?? '')).toUpperCase() || 'AD'

  const handleLogout = () => {
    logout()
    navigate('/auth/login')
  }

  return (
    <PageDataProvider>
      <div style={{display: 'flex', height: '100vh', background: '#f8fafc', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'}}>

        {/* ── Sidebar ── */}
        <aside style={{
          width: 260,
          flexShrink: 0,
          background: '#ffffff',
          borderRight: '1px solid #e2e8f0',
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: 100,
          overflowY: 'auto',
        }}>
          {/* Logo */}
          <div style={{padding: '24px 20px 20px', borderBottom: '1px solid #f1f5f9'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
              <img
                src={LOGO.appIcon}
                alt='Qwiksurv'
                style={{width: 36, height: 36, borderRadius: 8, objectFit: 'cover'}}
              />
              <span style={{fontSize: 16, fontWeight: 700, color: '#1e293b'}}>Qwiksurv Admin</span>
            </div>
          </div>

          {/* Nav items */}
          <nav style={{flex: 1, padding: '12px 12px'}}>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                style={({isActive}) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '9px 12px',
                  borderRadius: 8,
                  marginBottom: 2,
                  fontSize: 14,
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? BRAND.primary : '#64748b',
                  background: isActive ? BRAND.primaryLight : 'transparent',
                  textDecoration: 'none',
                  transition: 'all 0.15s',
                })}
              >
                {item.icon}
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Logout */}
          <div style={{padding: '12px 12px', borderTop: '1px solid #f1f5f9'}}>
            <button
              onClick={handleLogout}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 12px',
                borderRadius: 8,
                width: '100%',
                fontSize: 14,
                fontWeight: 400,
                color: '#ef4444',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4'/>
                <polyline points='16 17 21 12 16 7'/>
                <line x1='21' y1='12' x2='9' y2='12'/>
              </svg>
              Logout
            </button>
          </div>
        </aside>

        {/* ── Main area ── */}
        <div style={{marginLeft: 260, flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0}}>

          {/* Topbar */}
          <header style={{
            height: 64,
            background: '#ffffff',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '0 24px',
            position: 'sticky',
            top: 0,
            zIndex: 50,
            flexShrink: 0,
          }}>
            <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: '50%',
                  background: BRAND.gradient,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 13,
                  flexShrink: 0,
                }}
              >
                {initials}
              </div>
              <div>
                <div style={{fontSize: 13, fontWeight: 600, color: '#1e293b', lineHeight: 1.2}}>
                  {currentUser?.first_name} {currentUser?.last_name}
                </div>
                <div style={{fontSize: 12, color: '#94a3b8'}}>
                  {currentUser?.email}
                </div>
              </div>
            </div>
          </header>

          {/* Content */}
          <main style={{flex: 1, overflowY: 'auto', padding: '28px 28px'}}>
            <Outlet />
          </main>
        </div>
      </div>
    </PageDataProvider>
  )
}

export {MasterLayout}
